import React, { useEffect, useState } from 'react'
import './ManagerRequestAssignmentHistory.less'
import { getManagerRequestAssignmentHistory } from 'services/Manager';
import moment from 'moment';

const ManagerRequestAssignmentHistory = ({ loadHistoryData, manager, newAssignRequest, queryDate }) => {

    const [assignmentHistoryData, setAssignmentHistoryData] = useState([])
    const [newRequestIDs, setNewRequestIDs] = useState([]);

    useEffect(() => {
        if (manager && manager.userID) {
            loadData(manager.userID, queryDate);
        }
    }, [manager, loadHistoryData])


    useEffect(() => {
        if (newAssignRequest) {
            let newReqeust = newAssignRequest;
            let updatednewRequestIDs = newRequestIDs;
            updatednewRequestIDs.push(newReqeust.singleBuyerRequestID);
            setNewRequestIDs(updatednewRequestIDs);
            setAssignmentHistoryData([newReqeust, ...assignmentHistoryData]);

            const toRef = setTimeout(() => {
                let newReqeust = newAssignRequest;
                let updatednewRequestIDs = newRequestIDs;
                let idIndex = updatednewRequestIDs.findIndex((item) => { return item == newReqeust.singleBuyerRequestID })
                if (idIndex != -1) {
                    updatednewRequestIDs.splice(idIndex, 1);
                    setNewRequestIDs([...updatednewRequestIDs]);
                }
                clearTimeout(toRef);
            }, 120000);
        }
    }, [newAssignRequest])

    const loadData = async (managerID, queryDate) => {
        let res = await getManagerRequestAssignmentHistory(managerID, queryDate);
        if (res.resStatus == 200) {
            setAssignmentHistoryData(res.data);
            console.log(res);
        }
    }

    const isNewRequestAssigned = (sbr, newRequestIDs) => {
        if (newRequestIDs.length && newRequestIDs.find((id) => { return id == sbr.singleBuyerRequestID })
        ) {
            return true;
        }
        return false;
    }

    return (
        <>
            <div className={"manager-request-assignment-history-container"}>
                {
                    assignmentHistoryData.length > 0 && assignmentHistoryData.map((item) => {
                        return (
                            <div className={"request-detail-container"}>
                                <b>
                                    Request &nbsp;
                                    <a href={`/request/${item.singleBuyerRequestID}`} target="_blank">
                                        {item.singleBuyerRequestID}
                                    </a>
                                </b>
                                &nbsp;
                                {
                                    " assigned to you at : "
                                }
                                <b>
                                    {moment(item.assignedAt).format("HH:mm")}
                                </b>
                                {
                                    isNewRequestAssigned(item, newRequestIDs) ?
                                        <>
                                            <div className={"new"}>
                                                <p>
                                                    New
                                                </p>
                                            </div>
                                        </>
                                        : ""
                                }
                            </div>
                        )
                    })
                }
            </div>
        </>
    )
}

export default ManagerRequestAssignmentHistory